export function loadScript(url: string) {
  return new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = url;
    script.async = true;

    script.onload = () => {
      resolve();
    };

    script.onerror = (e) => {
      reject(e);
    };

    document.head.appendChild(script);
  });
}
